import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import MobileCTABar from './MobileCTABar';
import FloatingCallButton from './FloatingCallButton';
import ChatWidget from '@/components/chat/ChatWidget';

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return (
    <div className="flex flex-col min-h-screen bg-background">
      <Header />
      <main className="flex-1 pb-24 md:pb-0">
        <Outlet />
      </main>
      <Footer />
      <MobileCTABar />
      <FloatingCallButton />
      <ChatWidget />
    </div>
  );
}
